






























import { Component, Vue } from 'vue-property-decorator';
import { hideOverlay } from '@/util/common/overlay';

/**
 * 権限エラー画面.
 */
@Component({
  name: 'Forbidden'
})
export default class Forbidden extends Vue {
  // リダイレクトフラグ
  // NOTE：TRUE = 画面描写しない / FALSE = 画面描写される
  private isRedirect: boolean = false;
  public async mounted(): Promise<void> {
    hideOverlay();
  }
  private created() {
    const redirected = this.$route.query.redirected;
    if (!redirected) {
      // リダイレクト後は、クエリパラメータ（rediredted）が設定されてるため、trueにならない
      this.isRedirect = true;
      window.location.href = `${process.env.VUE_APP_HOST_URL}redirect/forbidden`;
    }
  }
}
